module.exports = __webpack_public_path__ + "img/1920x793px.ce7fb64b.png";